import React, { Component } from "react";
import Avatar from "react-avatar";
import { Link } from "react-router";
import { changeLocation } from "api/Location";

import dropdownArrowIcon from "containers/assets/icon-dropdown-arrow.svg";
import Auth from "routes/Auth";
import MyProfileLink from "./my-profile-link";
import TeamProfileLink from "./team-profile-link";

class HeaderUserGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false
    };
  }

  logout() {
    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
    }

    changeLocation("/login");
  }

  showMenu = (event) => {
    event.preventDefault();

    this.setState(
      {
        showMenu: true
      },
      () => {
        document.addEventListener("click", this.closeMenu);
      }
    );
  }

  closeMenu = () => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener("click", this.closeMenu);
    });
  }

  render() {
    const { name, team_color, position, isStudent } = this.props;
    return (
      <div className="header__user__group" onClick={this.showMenu}>
        {" "}
        <Avatar name={name} color={team_color} size={isStudent ? 50 : 45} round={true} />
        <p className="username">{name}</p>
        {position && (
          <p className="position">({position})</p>
        )}
        <img src={dropdownArrowIcon} className="icon-dropdown" alt="Dropdown" />
        {this.state.showMenu ? (
          <div className="menu">
            <ul className="drop__down__menu">
              {isStudent && (
                <li>
                  <MyProfileLink />
                </li>
              )}
              {isStudent && (
                <li>
                  <TeamProfileLink />
                </li>
              )}
              {isStudent && (
                <li>
                  <Link
                    to="/ceo/audit-trail"
                  >
                    Audit Trail
                  </Link>
                </li>
              )}
              <li>
                <button onClick={this.logout}>Log Off</button>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    );
  }
}

export default HeaderUserGroup;



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/header-user-group.js